var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMandala1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6644 73.311C28.1925 68.6286 21.5277 66.4161 16.5164 66.9501C17.4141 68.9204 18.693 70.6935 20.2793 72.1669C21.8652 73.6407 23.7277 74.786 25.7582 75.5368C24.9859 77.5595 24.6215 79.7149 24.6859 81.8794C24.7504 84.0435 25.2426 86.1735 26.1336 88.1466C29.8359 84.7275 32.5598 78.2548 30.6645 73.3106L30.6644 73.311ZM29.8449 48.669C31.4078 43.61 28.2597 37.333 24.3387 34.167H24.3383C23.5801 36.1951 23.2305 38.3533 23.3102 40.517C23.3899 42.6807 23.8965 44.8072 24.8016 46.774C22.8254 47.658 21.0434 48.9244 19.5586 50.5006C18.0738 52.0764 16.9156 53.9303 16.1504 55.9561C21.1863 56.1561 27.6894 53.5053 29.8444 48.669H29.8449ZM46.6899 30.665C51.3723 28.1931 53.5848 21.5283 53.0508 16.517C51.0805 17.4147 49.3074 18.6936 47.834 20.2799C46.3602 21.8658 45.2149 23.7283 44.4641 25.7588C42.4414 24.9866 40.286 24.6221 38.1215 24.6865C35.9574 24.751 33.8274 25.2432 31.8543 26.1342C35.2734 29.8365 41.7461 32.5604 46.6903 30.6651L46.6899 30.665ZM71.3319 29.8455C76.3909 31.4084 82.6679 28.2603 85.8339 24.3393V24.3389C83.8058 23.5807 81.6476 23.2311 79.4839 23.3108C77.3202 23.3905 75.1937 23.8971 73.2269 24.8022C72.3429 22.826 71.0765 21.044 69.5003 19.5592C67.9245 18.0744 66.0706 16.9162 64.0448 16.151C63.8448 21.1869 66.4956 27.69 71.3319 29.845V29.8455ZM89.3359 46.6905C91.8078 51.3729 98.4726 53.5854 103.484 53.0514C102.586 51.0811 101.307 49.308 99.721 47.8346C98.1351 46.3608 96.2726 45.2155 94.2421 44.4647C95.0144 42.442 95.3788 40.2866 95.3144 38.1221C95.2499 35.958 94.7578 33.828 93.8667 31.8549C90.1644 35.274 87.4405 41.7467 89.3358 46.6909L89.3359 46.6905ZM90.1554 71.3325C88.5925 76.3915 91.7406 82.6685 95.6616 85.8345H95.662C96.4202 83.8064 96.7698 81.6482 96.6901 79.4845C96.6104 77.3208 96.1038 75.1943 95.1987 73.2275C97.1749 72.3435 98.9569 71.0771 100.442 69.5009C101.927 67.9251 103.085 66.0712 103.85 64.0454C98.814 63.8454 92.3109 66.4962 90.1559 71.3325H90.1554ZM73.3104 89.3365C68.628 91.8084 66.4155 98.4732 66.9495 103.485C68.9198 102.587 70.6929 101.308 72.1663 99.7216C73.6401 98.1357 74.7854 96.2732 75.5362 94.2427C77.5589 95.015 79.7143 95.3794 81.8788 95.315C84.0429 95.2505 86.1729 94.7584 88.146 93.8673C84.7269 90.165 78.2542 87.4411 73.31 89.3364L73.3104 89.3365ZM48.6684 90.156C43.6094 88.5931 37.3324 91.7412 34.1664 95.6622V95.6626C36.1945 96.4208 38.3527 96.7704 40.5164 96.6907C42.6801 96.611 44.8066 96.1044 46.7734 95.1993C47.6574 97.1755 48.9238 98.9575 50.5 100.442C52.0758 101.927 53.9297 103.085 55.9555 103.851C56.1555 98.8146 53.5047 92.3115 48.6684 90.1565V90.156ZM46.0918 74.866C46.3008 79.068 47.65 83.1332 49.9949 86.626C54.0597 85.542 57.7523 83.3713 60.6769 80.3471C63.7957 83.1701 67.6246 85.0909 71.7519 85.9026C73.8593 82.2616 74.9355 78.1155 74.8648 73.9096C79.0668 73.7006 83.132 72.3514 86.6248 70.0065C85.5404 65.9417 83.3697 62.2491 80.3455 59.3245C83.1685 56.2057 85.0893 52.3768 85.901 48.2495C82.26 46.1421 78.1139 45.0659 73.908 45.1366C73.699 40.9346 72.3498 36.8694 70.0049 33.3766C65.9401 34.461 62.2475 36.6317 59.3229 39.6559C56.2041 36.8329 52.3752 34.9121 48.2479 34.1004C46.1405 37.7414 45.0643 41.8875 45.135 46.0934C40.933 46.3024 36.8678 47.6516 33.375 49.9965C34.4594 54.0613 36.6301 57.7539 39.6543 60.6785C36.8313 63.7973 34.9105 67.6262 34.0988 71.7535C37.7398 73.8609 41.8859 74.9371 46.0918 74.8664V74.866ZM46.4207 92.77C43.9379 94.4477 40.9164 95.1341 37.9523 94.6938C38.3414 94.5399 38.3426 94.5474 37.9293 94.6083L37.9297 94.6087C40.2762 92.7454 43.2363 91.829 46.225 92.0407C43.0137 93.5536 42.859 93.0677 46.4207 92.77ZM73.5687 92.7743C72.9996 95.7161 71.3484 98.338 68.9414 100.123C69.1074 99.7388 69.1137 99.7434 68.8649 100.079V100.078C69.2067 97.1012 70.6516 94.3606 72.9149 92.3966C71.7137 95.7376 71.2609 95.5028 73.5687 92.7743ZM92.7687 73.5803C94.4464 76.0631 95.1328 79.0846 94.6925 82.0487C94.5386 81.6597 94.5461 81.6585 94.607 82.0718L94.6074 82.0714C92.7441 79.7245 91.8277 76.7648 92.0394 73.7757C93.5523 76.9874 93.0664 77.142 92.7687 73.5803ZM92.773 46.4323C95.7148 47.0015 98.3367 48.6526 100.121 51.0596C99.7375 50.8936 99.7421 50.8874 100.077 51.1362H100.077C97.0999 50.7944 94.3593 49.3491 92.3953 47.0862C95.7363 48.2874 95.5015 48.7401 92.773 46.4323ZM73.579 27.2323C76.0618 25.5546 79.0833 24.8682 82.0474 25.3085C81.6584 25.4624 81.6572 25.455 82.0705 25.3941L82.0701 25.3937C79.7236 27.257 76.7635 28.1734 73.7748 27.9617C76.9861 26.4488 77.1407 26.9346 73.579 27.2323ZM46.431 27.228C47.0002 24.2862 48.6513 21.6643 51.0583 19.8796C50.8923 20.2636 50.8861 20.2589 51.1349 19.9238V19.9242C50.7931 22.9012 49.3482 25.6418 47.0849 27.6058C48.2861 24.2648 48.7388 24.4996 46.431 27.228ZM27.231 46.422C25.5533 43.9392 24.8669 40.9177 25.3072 37.9536C25.4611 38.3427 25.4537 38.3439 25.3928 37.9306L25.3924 37.931C27.2557 40.2775 28.1721 43.2376 27.9604 46.2263C26.4475 43.015 26.9333 42.8603 27.231 46.422ZM27.2267 73.57C24.2849 73.0009 21.663 71.3497 19.8783 68.9427C20.2623 69.1088 20.2576 69.115 19.9225 68.8662H19.9229C22.8999 69.208 25.6405 70.6529 27.6045 72.9162C24.2635 71.715 24.4983 71.2622 27.2267 73.57ZM28.9466 75.8743C29.3564 78.8427 28.6388 81.8567 26.9357 84.3223C26.1697 81.4039 26.6283 78.2996 28.206 75.7278C28.1463 79.2774 27.6416 79.2016 28.9466 75.8743ZM49.2666 93.1833C51.6553 94.9927 53.2791 97.6313 53.8182 100.579C51.2217 99.0478 49.3537 96.5321 48.6393 93.6036C51.1069 96.1556 50.6967 96.4587 49.2666 93.1833ZM75.8736 91.0544C78.842 90.6447 81.856 91.3622 84.3216 93.0653C81.4032 93.8317 78.2989 93.3728 75.7271 91.7954C79.2767 91.8548 79.201 92.3595 75.8736 91.0544ZM93.1826 70.7344C94.992 68.3457 97.6306 66.7219 100.578 66.1828C99.0471 68.7797 96.5314 70.6473 93.6029 71.3617C96.1549 68.8941 96.458 69.3044 93.1826 70.7344ZM91.0537 44.1274C90.644 41.159 91.3615 38.145 93.0646 35.6794C93.8307 38.5978 93.3721 41.7021 91.7943 44.2739C91.8541 40.7243 92.3588 40.8001 91.0537 44.1274ZM70.7337 26.8184C68.345 25.009 66.7212 22.3704 66.1821 19.4227C68.779 20.9539 70.6466 23.4696 71.361 26.3981C68.8934 23.8461 69.3037 23.543 70.7337 26.8184ZM44.1267 28.9473C41.1583 29.3571 38.1443 28.6395 35.6787 26.9364C38.5971 26.1704 41.7014 26.629 44.2732 28.2067C40.7236 28.147 40.7994 27.6423 44.1267 28.9473ZM26.8177 49.2673C25.0083 51.656 22.3697 53.2798 19.422 53.8189C20.9532 51.2224 23.4689 49.3544 26.3974 48.64C23.8454 51.1076 23.5423 50.6974 26.8177 49.2673ZM59.7967 60.5443C59.4416 60.2572 59.4393 60.2779 59.4577 59.7974C59.7448 59.4424 59.7241 59.44 60.2046 59.4584C60.5596 59.7455 60.562 59.7248 60.5436 60.2053C60.2565 60.5604 60.2772 60.5627 59.7967 60.5443ZM50.9721 84.0273C46.9069 77.1914 48.6725 72.8263 47.7584 72.8253C43.9135 73.1441 40.0564 72.3749 36.6274 70.6062C37.5446 66.857 39.5075 63.4453 42.2879 60.7683C42.893 60.0757 38.427 58.4894 35.9746 50.9726C42.8105 46.9074 47.1756 48.673 47.1766 47.7589H47.1762C46.8579 43.914 47.6266 40.0569 49.3953 36.6279C53.1445 37.5451 56.5562 39.508 59.2332 42.2884C59.9258 42.8935 61.5121 38.4275 69.0289 35.9751C73.0941 42.811 71.3285 47.1761 72.2426 47.1771V47.1767C76.0875 46.858 79.9446 47.6271 83.3736 49.3958C82.4568 53.145 80.4935 56.5567 77.7134 59.2337C77.1084 59.9263 81.5743 61.5126 84.0267 69.0294C77.1908 73.0946 72.8257 71.329 72.8247 72.2431C73.1435 76.088 72.3743 79.9451 70.6056 83.3741C66.8564 82.457 63.4447 80.494 60.7677 77.7136C60.0748 77.1086 58.4889 81.5745 50.9721 84.0273ZM57.9951 62.1443C59.1353 63.0646 58.5697 62.8736 60.0978 62.9346C61.5548 62.7791 61.0197 63.0443 62.1435 62.0064C63.0638 60.8662 62.8728 61.4318 62.9338 59.9037C62.7783 58.4467 63.0435 58.9819 62.0056 57.858C60.8654 56.9377 61.431 57.1287 59.9029 57.0678C58.4459 57.2233 58.9811 56.958 57.8572 57.9959C56.9369 59.1361 57.1279 58.5705 57.067 60.0986C57.2225 61.5556 56.9576 61.0205 57.9951 62.1443Z",
    fill: "url(#paint0_linear_1835_24825)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5037 76.564C44.6561 81.871 44.9432 83.4433 48.2951 87.773C48.5385 88.089 48.544 88.5277 48.3092 88.85C48.074 89.1723 47.6549 89.3012 47.2795 89.1664C43.3885 87.8469 42.5092 82.882 42.2502 78.9734C38.3326 78.9746 33.3201 78.4273 31.7452 74.6328L31.7448 74.6324C31.5854 74.2668 31.6862 73.8398 31.9921 73.584C32.2979 73.3282 32.7362 73.3047 33.0675 73.5262C37.5976 76.5742 39.1827 76.7657 44.5035 76.5645L44.5037 76.564Z",
    fill: "url(#paint1_linear_1835_24825)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3302 60.754C33.6853 64.6145 32.7767 65.929 32.0849 71.361C32.0333 71.7567 31.7271 72.0708 31.3333 72.1325C30.9392 72.1942 30.5517 71.9887 30.3814 71.6278C28.563 67.9434 31.4521 63.811 34.033 60.8638C31.2619 58.0947 28.1045 54.163 29.674 50.3658H29.6744C29.8201 49.9947 30.1931 49.7638 30.5904 49.799C30.9877 49.8345 31.3138 50.1279 31.3916 50.5189C32.4396 55.8775 33.4252 57.1334 37.3303 60.7539L37.3302 60.754Z",
    fill: "url(#paint2_linear_1835_24825)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4366 44.503C38.1296 44.6554 36.5573 44.9425 32.2276 48.2944C31.9115 48.5378 31.4729 48.5432 31.1506 48.3085C30.8283 48.0733 30.6994 47.6542 30.8341 47.2788C32.1536 43.3878 37.1185 42.5085 41.0271 42.2495C41.026 38.3319 41.5732 33.3194 45.3677 31.7445L45.3681 31.7441C45.7338 31.5847 46.1607 31.6855 46.4165 31.9914C46.6724 32.2972 46.6958 32.7355 46.4743 33.0668C43.4263 37.5969 43.2348 39.182 43.436 44.5028L43.4366 44.503Z",
    fill: "url(#paint3_linear_1835_24825)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2468 37.33C55.3863 33.6851 54.0718 32.7765 48.6398 32.0847C48.2441 32.0331 47.93 31.7269 47.8683 31.3331C47.8066 30.939 48.012 30.5515 48.373 30.3812C52.0574 28.5628 56.1898 31.4519 59.137 34.0328C61.9061 31.2617 65.8378 28.1043 69.635 29.6738V29.6742C70.0061 29.8199 70.2369 30.1929 70.2018 30.5902C70.1662 30.9875 69.8729 31.3136 69.4819 31.3914C64.1233 32.4394 62.8674 33.425 59.2469 37.3301L59.2468 37.33Z",
    fill: "url(#paint4_linear_1835_24825)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4973 43.436C75.345 38.129 75.0579 36.5567 71.7059 32.227C71.4626 31.911 71.4571 31.4723 71.6919 31.15C71.927 30.8277 72.3462 30.6988 72.7216 30.8336C76.6126 32.1531 77.4919 37.118 77.7509 41.0266C81.6685 41.0254 86.681 41.5727 88.2559 45.3672L88.2563 45.3676C88.4156 45.7332 88.3149 46.1602 88.009 46.416C87.7031 46.6718 87.2649 46.6953 86.9332 46.4738C82.4035 43.4258 80.8184 43.2343 75.4972 43.4355L75.4973 43.436Z",
    fill: "url(#paint5_linear_1835_24825)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M82.67 59.246C86.3149 55.3855 87.2235 54.071 87.9153 48.639C87.9669 48.2433 88.2731 47.9292 88.6669 47.8675C89.061 47.8058 89.4485 48.0113 89.6188 48.3722C91.4372 52.0566 88.5481 56.189 85.9672 59.1362C88.7383 61.9053 91.8957 65.837 90.3262 69.6342H90.3258C90.1801 70.0053 89.8071 70.2362 89.4098 70.201C89.0125 70.1655 88.6864 69.8721 88.6086 69.4811C87.5606 64.1225 86.575 62.8666 82.6699 59.2461L82.67 59.246Z",
    fill: "url(#paint6_linear_1835_24825)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5642 75.497C81.8712 75.3447 83.4435 75.0576 87.7732 71.7056C88.0892 71.4623 88.5279 71.4568 88.8502 71.6916C89.1725 71.9267 89.3014 72.3459 89.1666 72.7213C87.8471 76.6123 82.8822 77.4916 78.9736 77.7506C78.9748 81.6682 78.4275 86.6807 74.633 88.2556L74.6326 88.256C74.267 88.4153 73.84 88.3146 73.5842 88.0087C73.3283 87.7028 73.3049 87.2645 73.5264 86.9329C76.5744 82.4032 76.7659 80.8181 76.5647 75.4969L76.5642 75.497Z",
    fill: "url(#paint7_linear_1835_24825)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7535 82.67C64.614 86.3149 65.9285 87.2235 71.3605 87.9153C71.7562 87.9669 72.0702 88.2731 72.1319 88.6669C72.1937 89.061 71.9882 89.4485 71.6272 89.6188C67.9428 91.4372 63.8104 88.5481 60.8632 85.9672C58.0941 88.7383 54.1624 91.8957 50.3652 90.3262V90.3258C49.9942 90.1801 49.7633 89.8071 49.7984 89.4098C49.834 89.0126 50.1274 88.6864 50.5184 88.6087C55.877 87.5607 57.1329 86.5751 60.7534 82.67L60.7535 82.67Z",
    fill: "url(#paint8_linear_1835_24825)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8854 100.22C42.4327 100.005 39.9643 100.389 37.6932 101.34C37.4487 101.495 37.3194 101.781 37.3643 102.066C37.4088 102.352 37.6186 102.585 37.8987 102.658C39.9952 102.922 42.1233 102.756 44.1534 102.168C45.294 103.947 46.7858 105.474 48.5374 106.656C48.7963 106.785 49.1073 106.749 49.3292 106.563C49.551 106.377 49.6417 106.077 49.5596 105.799C48.4768 103.588 46.8729 101.673 44.8854 100.22Z",
    fill: "url(#paint9_linear_1835_24825)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8713 77.754C19.2893 75.8677 17.2721 74.3942 14.9936 73.461C14.7112 73.3977 14.4182 73.5079 14.2475 73.7415C14.0768 73.9755 14.0608 74.288 14.2069 74.5376C15.5026 76.2071 17.1257 77.5942 18.9764 78.6142C18.5248 80.6783 18.4998 82.813 18.9029 84.8872C18.9947 85.1618 19.2404 85.3559 19.5287 85.3813C19.817 85.4067 20.0928 85.2587 20.231 85.0048C21.0291 82.6755 21.249 80.1872 20.8713 77.754Z",
    fill: "url(#paint10_linear_1835_24825)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7781 44.886C19.9933 42.4333 19.609 39.9649 18.6578 37.6938C18.5027 37.4493 18.2176 37.32 17.9316 37.3649C17.6457 37.4094 17.4133 37.6192 17.3402 37.8993C17.0758 39.9958 17.2426 42.1239 17.8301 44.154C16.0512 45.2946 14.5242 46.7864 13.3422 48.538C13.2129 48.797 13.2496 49.1079 13.4355 49.3298C13.6215 49.5517 13.9211 49.6423 14.1988 49.5602C16.4101 48.4774 18.325 46.8735 19.7781 44.886Z",
    fill: "url(#paint11_linear_1835_24825)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2453 20.871C44.1316 19.289 45.6051 17.2718 46.5383 14.9933C46.6016 14.7109 46.4915 14.4179 46.2579 14.2472C46.0239 14.0765 45.7114 14.0605 45.4618 14.2066C43.7923 15.5023 42.4052 17.1254 41.3852 18.9761C39.3211 18.5246 37.1864 18.4996 35.1122 18.9027C34.8376 18.9945 34.6434 19.2402 34.618 19.5285C34.5927 19.8167 34.7407 20.0925 34.9946 20.2308C37.3239 21.0288 39.8121 21.2488 42.2453 20.871Z",
    fill: "url(#paint12_linear_1835_24825)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M75.114 19.777C77.5667 19.9922 80.0351 19.6079 82.3062 18.6567C82.5508 18.5016 82.6801 18.2165 82.6355 17.9305C82.591 17.6446 82.3809 17.4122 82.1008 17.3391C80.0043 17.0747 77.8762 17.2415 75.8461 17.829C74.7055 16.0501 73.2137 14.5231 71.4621 13.3411C71.2031 13.2118 70.8922 13.2485 70.6703 13.4344C70.4484 13.6204 70.3582 13.92 70.4398 14.1977C71.5226 16.409 73.1265 18.3239 75.114 19.777Z",
    fill: "url(#paint13_linear_1835_24825)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1289 42.246C100.711 44.1323 102.728 45.6058 105.007 46.539C105.289 46.6023 105.582 46.4921 105.753 46.2585C105.923 46.0246 105.939 45.7121 105.793 45.4625C104.498 43.793 102.875 42.4059 101.024 41.3859C101.475 39.3218 101.5 37.1871 101.097 35.1129C101.005 34.8382 100.76 34.6441 100.471 34.6187C100.183 34.5933 99.9074 34.7414 99.7691 34.9953C98.9711 37.3246 98.7511 39.8128 99.1289 42.246Z",
    fill: "url(#paint14_linear_1835_24825)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M100.22 75.114C100.005 77.5667 100.389 80.0351 101.341 82.3062C101.496 82.5507 101.781 82.68 102.067 82.6355C102.353 82.591 102.585 82.3808 102.658 82.1007C102.923 80.0042 102.756 77.8761 102.168 75.846C103.947 74.7054 105.474 73.2136 106.656 71.462C106.785 71.2031 106.749 70.8921 106.563 70.6702C106.377 70.4484 106.077 70.3581 105.8 70.4398C103.588 71.5226 101.673 73.1265 100.22 75.114Z",
    fill: "url(#paint15_linear_1835_24825)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M77.754 99.129C75.8677 100.711 74.3942 102.728 73.461 105.007C73.3977 105.289 73.5079 105.582 73.7415 105.753C73.9754 105.924 74.2879 105.94 74.5376 105.793C76.2071 104.498 77.5942 102.875 78.6142 101.024C80.6783 101.476 82.813 101.501 84.8872 101.097C85.1618 101.006 85.3559 100.76 85.3813 100.472C85.4067 100.183 85.2586 99.9075 85.0047 99.7693C82.6754 98.9712 80.1872 98.7513 77.754 99.129Z",
    fill: "url(#paint16_linear_1835_24825)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5258 87.228C36.1887 86.2042 37.9918 85.428 39.8785 84.9245C40.3852 84.7241 40.959 84.9609 41.1773 85.4601C41.3953 85.9593 41.1789 86.5413 40.6879 86.7769C38.6582 87.7144 33.3262 90.3328 33.6922 88.1191C31.5051 88.632 33.7715 83.1234 34.5668 81.0496H34.5664C34.7687 80.5441 35.3352 80.2894 35.8476 80.4738C36.3601 80.6582 36.6347 81.2152 36.4683 81.734C36.0914 83.65 35.4371 85.5008 34.5257 87.2281L34.5258 87.228Z",
    fill: "url(#paint17_linear_1835_24825)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7351 61.239C24.6347 61.691 26.4585 62.4175 28.1488 63.3952C28.6484 63.612 28.8871 64.185 28.6882 64.6921C28.4894 65.1991 27.925 65.4577 27.4112 65.2773C25.3132 64.505 19.6913 62.5863 21.5155 61.2796C19.6065 60.096 25.1042 57.803 27.1327 56.8991C27.6331 56.6846 28.2136 56.9053 28.4456 57.3979C28.6777 57.8909 28.4777 58.4788 27.9937 58.728C26.3722 59.8159 24.6007 60.662 22.7351 61.2389V61.239Z",
    fill: "url(#paint18_linear_1835_24825)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7727 34.525C33.7965 36.1879 34.5727 37.991 35.0762 39.8777C35.2766 40.3844 35.0399 40.9582 34.5407 41.1765C34.0415 41.3945 33.4595 41.1781 33.2239 40.6871C32.2864 38.6574 29.668 33.3254 31.8817 33.6914C31.3688 31.5043 36.8774 33.7707 38.9512 34.566V34.5656C39.4566 34.7679 39.7113 35.3343 39.527 35.8468C39.3426 36.3592 38.7856 36.6339 38.2668 36.4675C36.3508 36.0905 34.5 35.4363 32.7727 34.5249L32.7727 34.525Z",
    fill: "url(#paint19_linear_1835_24825)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7617 22.734C58.3097 24.6336 57.5832 26.4574 56.6055 28.1477C56.3887 28.6473 55.8156 28.886 55.3086 28.6871C54.8015 28.4883 54.543 27.9239 54.7234 27.4102C55.4957 25.3122 57.4144 19.6902 58.7211 21.5144C59.9047 19.6054 62.1977 25.1031 63.1016 27.1316C63.3161 27.632 63.0954 28.2125 62.6028 28.4445C62.1098 28.6766 61.5219 28.4766 61.2727 27.9926C60.1848 26.3711 59.3387 24.5996 58.7618 22.734H58.7617Z",
    fill: "url(#paint20_linear_1835_24825)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4745 32.772C83.8116 33.7958 82.0085 34.572 80.1218 35.0755C79.6152 35.2759 79.0413 35.0392 78.823 34.5399C78.6051 34.0407 78.8215 33.4587 79.3125 33.2231C81.3422 32.2856 86.6742 29.6672 86.3082 31.8809C88.4953 31.3681 86.2289 36.8766 85.4336 38.9504H85.434C85.2316 39.4559 84.6652 39.7106 84.1528 39.5262C83.6403 39.3418 83.3657 38.7848 83.5321 38.266C83.909 36.35 84.5633 34.4992 85.4747 32.7719L85.4745 32.772Z",
    fill: "url(#paint21_linear_1835_24825)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2653 58.761C95.3657 58.3091 93.5419 57.5825 91.8516 56.6048C91.352 56.388 91.1134 55.815 91.3122 55.3079C91.511 54.8009 92.0755 54.5423 92.5892 54.7228C94.6872 55.495 100.309 57.4137 98.4849 58.7204C100.394 59.904 94.8962 62.197 92.8677 63.1009C92.3673 63.3154 91.7868 63.0947 91.5548 62.6021C91.3228 62.1092 91.5228 61.5212 92.0067 61.272C93.6282 60.1841 95.3997 59.338 97.2653 58.7611V58.761Z",
    fill: "url(#paint22_linear_1835_24825)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2282 85.475C86.2044 83.8121 85.4282 82.009 84.9247 80.1223C84.7243 79.6157 84.9611 79.0418 85.4603 78.8235C85.9595 78.6055 86.5415 78.822 86.7771 79.313C87.7146 81.3427 90.333 86.6747 88.1193 86.3087C88.6322 88.4958 83.1236 86.2294 81.0498 85.4341V85.4344C80.5443 85.2321 80.2896 84.6657 80.474 84.1532C80.6584 83.6408 81.2154 83.3661 81.7342 83.5326C83.6502 83.9095 85.501 84.5637 87.2283 85.4751L87.2282 85.475Z",
    fill: "url(#paint23_linear_1835_24825)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2402 97.266C61.6921 95.3664 62.4187 93.5426 63.3964 91.8523C63.6132 91.3527 64.1862 91.114 64.6933 91.3129C65.2003 91.5117 65.4589 92.0761 65.2785 92.5899C64.5062 94.6879 62.5875 100.31 61.2808 98.4856C60.0972 100.395 57.8042 94.8969 56.9003 92.8684C56.6858 92.368 56.9065 91.7875 57.3991 91.5555C57.8921 91.3234 58.48 91.5234 58.7292 92.0074C59.8171 93.6289 60.6632 95.4004 61.2401 97.266H61.2402Z",
    fill: "url(#paint24_linear_1835_24825)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3386 99.183C23.6144 99.9873 24.5667 101.002 25.1804 100.816C26.084 101.708 27.3042 102.206 28.5738 102.201C29.8433 102.196 31.0593 101.689 31.9562 100.79C34.1355 98.5112 32.7656 93.2702 29.7402 92.3413C28.6218 89.4093 23.3058 88.3503 21.1632 90.6917C20.3253 91.6452 19.8991 92.8913 19.978 94.1581C20.0569 95.4249 20.6339 96.6093 21.5835 97.4515C21.4433 98.1269 22.5546 98.9713 23.3386 99.183Z",
    fill: "url(#paint25_linear_1835_24825)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M6.37053 61.784C5.9967 62.5477 5.95256 63.9383 6.51819 64.241C6.52639 65.5105 7.03694 66.7254 7.93849 67.6195C8.83966 68.5141 10.0584 69.0148 11.328 69.0133C14.4803 68.9434 17.2175 64.2684 15.735 61.4723C17.0174 58.6082 14.0073 54.1004 10.8366 54.2411C9.57019 54.3228 8.38739 54.9029 7.54749 55.8544C6.70726 56.806 6.27839 58.0513 6.35409 59.3185C5.77714 59.6971 5.96581 61.0798 6.37049 61.7841L6.37053 61.784Z",
    fill: "url(#paint26_linear_1835_24825)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8169 23.339C20.0126 23.6148 18.9981 24.5671 19.1837 25.1808C18.2919 26.0843 17.7939 27.3046 17.7989 28.5742C17.8039 29.8437 18.3114 31.0597 19.2102 31.9566C21.4887 34.1359 26.7297 32.766 27.6586 29.7406C30.5906 28.6222 31.6496 23.3062 29.3082 21.1636C28.3546 20.3257 27.1086 19.8995 25.8418 19.9784C24.575 20.0573 23.3906 20.6343 22.5484 21.5839C21.873 21.4437 21.0286 22.555 20.8169 23.339Z",
    fill: "url(#paint27_linear_1835_24825)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2156 6.37031C57.452 5.99648 56.0613 5.95234 55.7586 6.51797C54.4891 6.52618 53.2742 7.03672 52.3801 7.93827C51.4856 8.83944 50.9848 10.0582 50.9863 11.3278C51.0563 14.4801 55.7312 17.2173 58.5273 15.7348C61.3914 17.0172 65.8992 14.0071 65.7585 10.8364C65.6769 9.56997 65.0968 8.38717 64.1452 7.54727C63.1937 6.70704 61.9483 6.27817 60.6811 6.35387C60.3026 5.77692 58.9198 5.96559 58.2155 6.37028L58.2156 6.37031Z",
    fill: "url(#paint28_linear_1835_24825)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6607 20.817C96.3849 20.0127 95.4326 18.9982 94.8189 19.1838C93.9154 18.292 92.6951 17.794 91.4255 17.799C90.156 17.8041 88.94 18.3115 88.0431 19.2103C85.8638 21.4888 87.2337 26.7302 90.2591 27.6591C91.3775 30.5911 96.6935 31.6501 98.8361 29.3087V29.3083C99.674 28.3548 100.1 27.1087 100.021 25.8419C99.9424 24.5751 99.3654 23.3907 98.4158 22.5485C98.556 21.8731 97.4447 21.0287 96.6607 20.817Z",
    fill: "url(#paint29_linear_1835_24825)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M113.63 58.216C114.004 57.4523 114.048 56.0617 113.483 55.759C113.474 54.4895 112.964 53.2746 112.062 52.3805C111.161 51.486 109.942 50.9852 108.673 50.9867C105.52 51.0566 102.783 55.7316 104.266 58.5277C102.983 61.3918 105.993 65.8996 109.164 65.7589C110.431 65.6773 111.613 65.0972 112.453 64.1456C113.293 63.194 113.722 61.9487 113.647 60.6815C114.224 60.303 114.035 58.9202 113.63 58.2159L113.63 58.216Z",
    fill: "url(#paint30_linear_1835_24825)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1835 96.661C99.9878 96.3853 101.002 95.4329 100.817 94.8192C101.708 93.9157 102.206 92.6954 102.201 91.4258C102.196 90.1563 101.689 88.9403 100.79 88.0434C98.5117 85.8641 93.2707 87.2341 92.3418 90.2594C89.4098 91.3778 88.3508 96.6938 90.6922 98.8364C91.6457 99.6743 92.8918 100.101 94.1586 100.022C95.4254 99.9427 96.6098 99.3658 97.452 98.4161C98.1274 98.5564 98.9718 97.445 99.1835 96.661Z",
    fill: "url(#paint31_linear_1835_24825)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7844 113.63C62.5481 114.004 63.9387 114.048 64.2414 113.482C65.5109 113.474 66.7258 112.964 67.6199 112.062C68.5144 111.161 69.0152 109.942 69.0137 108.673C68.9438 105.52 64.2688 102.783 61.4727 104.266C58.6086 102.983 54.1008 105.993 54.2415 109.164C54.3231 110.43 54.9032 111.613 55.8548 112.453C56.8064 113.293 58.0517 113.722 59.3189 113.646C59.6974 114.223 61.0802 114.035 61.7845 113.63L61.7844 113.63Z",
    fill: "url(#paint32_linear_1835_24825)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9996 66.9C58.1695 66.9 56.4144 66.1731 55.1207 64.8789C53.8266 63.5851 53.0996 61.8301 53.0996 60C53.0996 58.1699 53.8266 56.4148 55.1207 55.1211C56.4145 53.827 58.1695 53.1 59.9996 53.1C61.8297 53.1 63.5848 53.827 64.8785 55.1211C66.1726 56.4149 66.8996 58.1699 66.8996 60C66.8977 61.8293 66.1699 63.5832 64.8766 64.877C63.5828 66.1704 61.8289 66.8981 59.9996 66.9ZM59.9996 54.9C58.6469 54.9 57.3496 55.4375 56.3934 56.3938C55.4372 57.3501 54.8996 58.6473 54.8996 60C54.8996 61.3527 55.4371 62.65 56.3934 63.6062C57.3497 64.5624 58.6469 65.1 59.9996 65.1C61.3523 65.1 62.6496 64.5625 63.6058 63.6062C64.562 62.6499 65.0996 61.3527 65.0996 60C65.098 58.648 64.5602 57.3516 63.6043 56.3953C62.6481 55.4394 61.3516 54.9015 59.9996 54.9Z",
    fill: "url(#paint33_linear_1835_24825)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0004 71.1C57.0566 71.1 54.2332 69.9305 52.1516 67.8488C50.07 65.7672 48.9004 62.9437 48.9004 60C48.9004 57.0563 50.0699 54.2328 52.1516 52.1512C54.2332 50.0696 57.0567 48.9 60.0004 48.9C62.9441 48.9 65.7676 50.0695 67.8492 52.1512C69.9308 54.2328 71.1004 57.0563 71.1004 60C71.0973 62.943 69.9266 65.7645 67.8457 67.8453C65.7648 69.9261 62.9434 71.0969 60.0004 71.1ZM60.0004 50.7C57.534 50.7 55.1684 51.6797 53.4242 53.4238C51.6801 55.1679 50.7004 57.5336 50.7004 60C50.7004 62.4664 51.6801 64.832 53.4242 66.5762C55.1683 68.3203 57.534 69.3 60.0004 69.3C62.4668 69.3 64.8324 68.3203 66.5766 66.5762C68.3207 64.8321 69.3004 62.4664 69.3004 60C69.2977 57.5344 68.3168 55.1703 66.5734 53.427C64.83 51.6836 62.466 50.7028 60.0004 50.7Z",
    fill: "url(#paint34_linear_1835_24825)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1835_24825",
    x1: 28.6476,
    y1: 138.93,
    x2: 159.743,
    y2: 19.2109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1835_24825",
    x1: 30.5772,
    y1: 93.9727,
    x2: 53.5533,
    y2: 85.4935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1835_24825",
    x1: 28.731,
    y1: 78.8477,
    x2: 41.0741,
    y2: 77.2966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1835_24825",
    x1: 29.7514,
    y1: 53.5243,
    x2: 51.9676,
    y2: 46.2417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1835_24825",
    x1: 46.4048,
    y1: 39.7524,
    x2: 64.4158,
    y2: 22.4139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1835_24825",
    x1: 70.4268,
    y1: 51.3785,
    x2: 93.4029,
    y2: 42.8994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1835_24825",
    x1: 82.1451,
    y1: 76.9089,
    x2: 94.4882,
    y2: 75.3578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1835_24825",
    x1: 72.3451,
    y1: 93.3743,
    x2: 94.5613,
    y2: 86.0917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1835_24825",
    x1: 48.3423,
    y1: 93.1667,
    x2: 66.3533,
    y2: 75.8282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1835_24825",
    x1: 36.5603,
    y1: 108.704,
    x2: 49.9442,
    y2: 100.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1835_24825",
    x1: 13.6561,
    y1: 88.9664,
    x2: 24.0144,
    y2: 86.8714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1835_24825",
    x1: 12.8385,
    y1: 53.2603,
    x2: 22.6974,
    y2: 51.4186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1835_24825",
    x1: 33.8391,
    y1: 23.1338,
    x2: 47.4952,
    y2: 14.9656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1835_24825",
    x1: 69.6149,
    y1: 21.8063,
    x2: 82.999,
    y2: 13.1388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1835_24825",
    x1: 98.4979,
    y1: 50.1389,
    x2: 108.856,
    y2: 48.0439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1835_24825",
    x1: 99.735,
    y1: 86.3144,
    x2: 109.594,
    y2: 84.4727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1835_24825",
    x1: 72.6672,
    y1: 107.976,
    x2: 86.3233,
    y2: 99.8078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1835_24825",
    x1: 32.2134,
    y1: 91.5565,
    x2: 44.0051,
    y2: 87.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1835_24825",
    x1: 20.6226,
    y1: 67.8899,
    x2: 31.4328,
    y2: 64.5177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1835_24825",
    x1: 30.4585,
    y1: 43.8102,
    x2: 42.3091,
    y2: 39.6521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1835_24825",
    x1: 54.1124,
    y1: 31.0489,
    x2: 65.6094,
    y2: 26.5903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1835_24825",
    x1: 78.186,
    y1: 42.1576,
    x2: 89.9777,
    y2: 38.092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1835_24825",
    x1: 90.7456,
    y1: 65.7381,
    x2: 101.556,
    y2: 62.3659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1835_24825",
    x1: 79.8569,
    y1: 89.7842,
    x2: 91.7075,
    y2: 85.6261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1835_24825",
    x1: 56.2647,
    y1: 101.174,
    x2: 67.7617,
    y2: 96.7151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1835_24825",
    x1: 19.1202,
    y1: 106.038,
    x2: 37.1219,
    y2: 99.6471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1835_24825",
    x1: 5.3299,
    y1: 73.446,
    x2: 20.2515,
    y2: 69.8776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1835_24825",
    x1: 16.9675,
    y1: 36.9393,
    x2: 34.7609,
    y2: 30.876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1835_24825",
    x1: 50.0259,
    y1: 19.1966,
    x2: 68.2944,
    y2: 9.95518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1835_24825",
    x1: 86.1281,
    y1: 34.4258,
    x2: 104.13,
    y2: 28.0352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1835_24825",
    x1: 103.191,
    y1: 70.1947,
    x2: 118.113,
    y2: 66.6264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1835_24825",
    x1: 88.5808,
    y1: 103.947,
    x2: 106.374,
    y2: 97.8838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1835_24825",
    x1: 53.2779,
    y1: 117.058,
    x2: 71.5463,
    y2: 107.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1835_24825",
    x1: 52.2026,
    y1: 71.04,
    x2: 71.3188,
    y2: 64.3911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1835_24825",
    x1: 47.4574,
    y1: 77.76,
    x2: 78.2096,
    y2: 67.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMandala1);
export default __webpack_public_path__ + "static/media/mandala-1.238a23f484a5613f90b128bd3e758ab2.svg";
export { ForwardRef as ReactComponent };